import WatchTourDialog from "./WatchTourDialog";

export default WatchTourDialog;
export { WatchTourDialog };
